import React from 'react';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { conformToMask } from 'react-text-mask';

import './index.css';

export const formatCurrency = (amount, hideCents = false) => {
  let displayString = '$--.--';

  if (Number.isFinite(amount)) {
    displayString = conformToMask(amount.toFixed(2), createNumberMask({
      prefix: '$',
      allowDecimal: true,
      requireDecimal: true,
      allowNegative: true,
    })).conformedValue;
  }
  if (hideCents && displayString.endsWith('.00')) {
    return displayString.split('.')[0];
  }
  return displayString;
};

const Currency = ({ amount, hideCents, ...props }) => {
  const displayString = formatCurrency(amount, hideCents);

  return (
    <div
      styleName="currency"
      {...props}
    >
      {displayString}
    </div>
  );
};

Currency.propTypes = {
  amount: PropTypes.number,
  hideCents: PropTypes.bool,
};

Currency.defaultProps = {
  amount: null,
  hideCents: undefined,
};

export default Currency;



// WEBPACK FOOTER //
// ./src/components/Currency/index.js